var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observable, computed, action } from "mobx";
var TooltipData = /** @class */ (function () {
    function TooltipData() {
        this.isVisible = false;
        this.message = "";
        this.coors = {
            x: 0,
            y: 0
        };
        this.elRef = React.createRef();
    }
    Object.defineProperty(TooltipData, "getInstance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: true,
        configurable: true
    });
    TooltipData.prototype.changeVisibility = function (status) {
        if (status === void 0) { status = false; }
        return this.isVisible = status;
    };
    TooltipData.prototype.changeMessage = function (msg) {
        if (msg === void 0) { msg = ""; }
        return this.message = msg;
    };
    TooltipData.prototype.changeCoordinates = function (e, x, y) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        var currentEl = this.elRef.current;
        if (currentEl && currentEl.getBoundingClientRect().right >= document.body.offsetWidth) {
            return this.coors = {
                x: e.pageX - currentEl.getBoundingClientRect().width - 10,
                y: y
            };
        }
        return this.coors = {
            x: x,
            y: y
        };
    };
    TooltipData.prototype.show = function (e) {
        var _this = this;
        var target = e.target;
        if (target.nodeType === 1 && target.dataset && target.dataset.tooltipMessage) {
            this.changeVisibility(true);
            setTimeout(function () {
                _this.changeCoordinates(e, e.pageX, e.pageY);
            }, 100);
            this.changeMessage(target.dataset.tooltipMessage);
        }
    };
    TooltipData.prototype.hide = function (e) {
        this.changeVisibility(false);
        this.changeCoordinates(e, e.pageX, e.pageY);
        this.changeMessage("");
    };
    Object.defineProperty(TooltipData.prototype, "getPosStyles", {
        get: function () {
            return {
                top: this.coors.y + 10 + "px",
                left: this.coors.x + 10 + "px"
            };
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], TooltipData.prototype, "isVisible", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], TooltipData.prototype, "message", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], TooltipData.prototype, "coors", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TooltipData.prototype, "changeVisibility", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TooltipData.prototype, "changeMessage", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent, Object, Object]),
        __metadata("design:returntype", Object)
    ], TooltipData.prototype, "changeCoordinates", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], TooltipData.prototype, "show", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], TooltipData.prototype, "hide", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TooltipData.prototype, "getPosStyles", null);
    return TooltipData;
}());
export { TooltipData };
//# sourceMappingURL=TooltipData.js.map